wbApp.directive('wbFullCourseStamp', ['$timeout', '$translate',
    function ($timeout, $translate) {

        return {
            restrict: 'A',            
            priority: 1,
            scope: {
                stampSize: '@',
                allowBooking: '='
            },
            template: "<div class='rubber_stamp' ng-class='{\"rubber_stamp_medium\": stampSize==\"medium\", \"rubber_stamp_small\": stampSize==\"small\"}'>" +
                      "  <div class='rubber_stamp_title'>{{'TXT_COURSE_IS_FULL' | translate}}</div>" +
                      "  <div ng-if='allowBooking' class='rubber_stamp_sub_title'>{{'TXT_COURSE_IS_FULL_SUB_TITLE' | translate}}</div>" +
                      "</div>",
            link: function (scope, elm, attrs, ctrl) {
            }
        }
    }]);
